// @flow
import React, { PureComponent } from "react";
import css from "./Loader.css";
import { type Props } from "./";

type State = {};

// PureComponent can be optimized better than stateless!
// Ref: https://tribou.page.link/pure
export default class Loader extends PureComponent<Props, State> {
  render() {
    return (
      <div className={css["la-pacman"]}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js